module.exports = __webpack_public_path__ + "img/pricing-silver.d82ca8c4.png";